import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
const BazarButton = styled(Button)({
  minWidth: 0,
  minHeight: 0
});
export default BazarButton;
